import React from "react";
import {Box,Grid,MenuItem,TextField,CircularProgress, FormControlLabel, Checkbox} from "@mui/material";
import { usePaymentMethods } from "services/hooks/rentals";


const AddTenantPaymentForm = ({
  handleChangeAmount,
  handleChangeDatePaid,
  handleChangePaymentMethod,
  paymentMethod,
  handleInitialPayment,
  datePaid,
  initialPayment,
  handleSecurityDeposit,
  hasSecurityDeposit,
  errors
}) => {
  const { paymentMethods, isLoadingPaymentMethods } = usePaymentMethods();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Amount Paid"
            type="number"
            name="amount"
            onChange={handleChangeAmount}
            variant="outlined"
            fullWidth
            error={Boolean(errors.amount)}
            helperText={errors.amount}
          />
        </Grid>

        <Grid item xs={6}>
          {isLoadingPaymentMethods ? (
            <CircularProgress size={24} sx={{ ml: 2 }} />
          ) : (
            <TextField
              label="Payment Method"
              name="payment_method"
              select
              fullWidth
              error={Boolean(errors.payment_method)}
              helperText={errors.payment_method}
              value={paymentMethod}
              onChange={handleChangePaymentMethod}
            >
              {paymentMethods.map((method) => (
                <MenuItem key={method.id} value={method.id}>
                  {method.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Date Paid"
            type="date"
            name="date_paid"
            value={datePaid}
            onChange={handleChangeDatePaid}
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.date_paid)}
            helperText={errors.date_paid || "When the payment was received — allocation month is assigned automatically."}
          />
        </Grid>

        <Grid item xs={6}>
          <FormControlLabel
            label="Is this an initial Payment?"
            control={
              <Checkbox
                checked={initialPayment}
                onChange={handleInitialPayment}
              />
            }
          />
        </Grid>

        {initialPayment && (
          <Grid item xs={12}>
            <FormControlLabel
              label="Does this initial payment have a security deposit?"
              control={
                <Checkbox
                  checked={hasSecurityDeposit}
                  onChange={handleSecurityDeposit}
                />
              }
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default AddTenantPaymentForm;
